class BulletPoint extends HTMLElement {
  connectedCallback() {
    const parent = this.closest('.hf-hotspot-image');
    if (!parent) return;

    const color = parent.dataset.bulletColor;
    if (color) this.classList.add('color-' + color);

    const contain = parent.dataset.containBullet;
    if (contain) this.dataset.contain = contain;

    const titleStyle = parent.dataset.bulletTitleStyle;
    const titleStyleMobile = parent.dataset.bulletTitleStyleMobile || titleStyle;
    const title = this.querySelector('.bullet-point__title');
    if (title && titleStyle) {
      title.classList.add('hf-typo-preset', 'hf-typo-preset--' + titleStyle);
      if (titleStyleMobile) title.classList.add('hf-typo-preset--mobile-' + titleStyleMobile);
    }

    const textStyle = parent.dataset.bulletTextStyle;
    const textStyleMobile = parent.dataset.bulletTextStyleMobile || textStyle;
    const text = this.querySelector('.bullet-point__text');
    if (text && textStyle) {
      text.classList.add('hf-typo-preset', 'hf-typo-preset--' + textStyle);
      if (textStyleMobile) text.classList.add('hf-typo-preset--mobile-' + textStyleMobile);
    }
  }
}

if (!customElements.get('bullet-point')) {
  customElements.define('bullet-point', BulletPoint);
}
